export class Template {
    constructor(title, description, categories, categoryIds, properties, groupBy, searchValue) {
        this.userCreated = true;
        this.title = title; // string
        this.descreption = description; // string
        this.categories = categories; // [] of strings
        this.categoryIds = categoryIds; // [] of ints
        this.properties = properties; // [] of strings
        this.groupBy = groupBy; // [] of strings
        this.searchValue = searchValue; // string
        this.creationTime = Date.now();
    }
}

export class Collection {
    constructor(properties, groupedBy) {
        this.title = "";
        this.descreption = "";
        this.creationTime = Date.now();
        this.properties = properties;
        this.groupBy = groupedBy;
        this.elements = [];
        this.color = ""; // 6 digits color string - rrggbb
    }
}


export class BimsearchElement {
    constructor(elementModelId) {
        this.id = elementModelId;
        this.propertiesValues = new Object();
    }
}

export class ElementModelId {
    constructor(linkId, revitId) {
        this.linkId = linkId;
        this.revitId = revitId;
    }
}

export function modelIdToKey(elementModelId) {
    return elementModelId.linkId + "," + elementModelId.revitId;
}
